// Auto-extracted from calculadora_emergent_completa.docx - Numbeo jun. 2026
export const CIDADES = {
  'Lisboa': {
    fonte: 'numbeo_direto',
    alimentacao: 320, refeicao_barata: 12, restaurante_dois: 50, cinema: 8, creche: 448,
    t0c: 700,  t0p: 560,  t1c: 920,  t1p: 729,
    t2c: 1200, t2p: 950,  t3c: 1553, t3p: 1167,
    passe: 40, util: 120,
  },
  'Porto': {
    fonte: 'numbeo_direto',
    alimentacao: 290, refeicao_barata: 12, restaurante_dois: 50, cinema: 8, creche: 380,
    t0c: 600,  t0p: 470,  t1c: 800,  t1p: 620,
    t2c: 1050, t2p: 820,  t3c: 1300, t3p: 980,
    passe: 40, util: 110,
  },
  'Braga': {
    fonte: 'numbeo_direto',
    alimentacao: 260, refeicao_barata: 10, restaurante_dois: 40, cinema: 7, creche: 320,
    t0c: 480,  t0p: 370,  t1c: 620,  t1p: 480,
    t2c: 820,  t2p: 640,  t3c: 1000, t3p: 780,
    passe: 30, util: 105,
  },
  'Coimbra': {
    fonte: 'numbeo_direto',
    alimentacao: 255, refeicao_barata: 9, restaurante_dois: 38, cinema: 7, creche: 300,
    t0c: 450,  t0p: 350,  t1c: 580,  t1p: 440,
    t2c: 760,  t2p: 590,  t3c: 950,  t3p: 720,
    passe: 30, util: 100,
  },
  'Aveiro': {
    fonte: 'numbeo_direto',
    alimentacao: 255, refeicao_barata: 9, restaurante_dois: 38, cinema: 7, creche: 290,
    t0c: 440,  t0p: 340,  t1c: 560,  t1p: 420,
    t2c: 740,  t2p: 570,  t3c: 900,  t3p: 680,
    passe: 30, util: 100,
  },
  'Faro': {
    fonte: 'numbeo_direto',
    alimentacao: 270, refeicao_barata: 11, restaurante_dois: 45, cinema: 8, creche: 340,
    t0c: 560,  t0p: 430,  t1c: 720,  t1p: 550,
    t2c: 940,  t2p: 720,  t3c: 1150, t3p: 860,
    passe: 35, util: 112,
  },
  'Funchal': {
    fonte: 'numbeo_direto',
    alimentacao: 275, refeicao_barata: 10, restaurante_dois: 42, cinema: 7.5, creche: 340,
    t0c: 580,  t0p: 450,  t1c: 750,  t1p: 580,
    t2c: 980,  t2p: 750,  t3c: 1200, t3p: 900,
    passe: 35, util: 115,
  },
  'Cascais': {
    fonte: 'estimativa_regional',
    alimentacao: 330, refeicao_barata: 13, restaurante_dois: 55, cinema: 9, creche: 500,
    t0c: 780,  t0p: 620,  t1c: 1020, t1p: 810,
    t2c: 1330, t2p: 1060, t3c: 1730, t3p: 1300,
    passe: 40, util: 128,
  },
  'Sintra': {
    fonte: 'estimativa_regional',
    alimentacao: 295, refeicao_barata: 11, restaurante_dois: 46, cinema: 8, creche: 430,
    t0c: 620,  t0p: 490,  t1c: 800,  t1p: 625,
    t2c: 1050, t2p: 825,  t3c: 1360, t3p: 1020,
    passe: 40, util: 114,
  },
  'Setúbal': {
    fonte: 'estimativa_regional',
    alimentacao: 248, refeicao_barata: 9.5, restaurante_dois: 38, cinema: 7, creche: 290,
    t0c: 420,  t0p: 330,  t1c: 540,  t1p: 415,
    t2c: 710,  t2p: 550,  t3c: 870,  t3p: 660,
    passe: 35, util: 98,
  },
  'Almada': {
    fonte: 'estimativa_regional',
    alimentacao: 262, refeicao_barata: 10, restaurante_dois: 40, cinema: 7.5, creche: 360,
    t0c: 580,  t0p: 460,  t1c: 750,  t1p: 590,
    t2c: 980,  t2p: 770,  t3c: 1270, t3p: 960,
    passe: 40, util: 110,
  },
  'Loures': {
    fonte: 'estimativa_regional',
    alimentacao: 256, refeicao_barata: 10, restaurante_dois: 38, cinema: 7, creche: 340,
    t0c: 545,  t0p: 430,  t1c: 705,  t1p: 555,
    t2c: 920,  t2p: 720,  t3c: 1195, t3p: 900,
    passe: 40, util: 105,
  },
  'Odivelas': {
    fonte: 'estimativa_regional',
    alimentacao: 256, refeicao_barata: 10, restaurante_dois: 38, cinema: 7, creche: 340,
    t0c: 545,  t0p: 430,  t1c: 705,  t1p: 555,
    t2c: 920,  t2p: 720,  t3c: 1195, t3p: 900,
    passe: 40, util: 105,
  },
  'Amadora': {
    fonte: 'estimativa_regional',
    alimentacao: 252, refeicao_barata: 10, restaurante_dois: 37, cinema: 7, creche: 325,
    t0c: 520,  t0p: 410,  t1c: 675,  t1p: 530,
    t2c: 880,  t2p: 690,  t3c: 1145, t3p: 860,
    passe: 40, util: 102,
  },
  'Oeiras': {
    fonte: 'estimativa_regional',
    alimentacao: 308, refeicao_barata: 12, restaurante_dois: 48, cinema: 8.5, creche: 470,
    t0c: 700,  t0p: 556,  t1c: 910,  t1p: 720,
    t2c: 1190, t2p: 940,  t3c: 1545, t3p: 1165,
    passe: 40, util: 121,
  },
  'Vila Nova de Gaia': {
    fonte: 'estimativa_regional',
    alimentacao: 272, refeicao_barata: 11, restaurante_dois: 44, cinema: 7.5, creche: 355,
    t0c: 510,  t0p: 400,  t1c: 660,  t1p: 510,
    t2c: 860,  t2p: 670,  t3c: 1115, t3p: 840,
    passe: 40, util: 103,
  },
  'Matosinhos': {
    fonte: 'estimativa_regional',
    alimentacao: 277, refeicao_barata: 11, restaurante_dois: 45, cinema: 7.5, creche: 360,
    t0c: 530,  t0p: 415,  t1c: 685,  t1p: 530,
    t2c: 895,  t2p: 700,  t3c: 1160, t3p: 875,
    passe: 40, util: 105,
  },
  'Guimarães': {
    fonte: 'estimativa_regional',
    alimentacao: 250, refeicao_barata: 9.5, restaurante_dois: 37, cinema: 7, creche: 310,
    t0c: 420,  t0p: 325,  t1c: 540,  t1p: 415,
    t2c: 705,  t2p: 550,  t3c: 915,  t3p: 690,
    passe: 30, util: 95,
  },
  'Barcelos': {
    fonte: 'estimativa_regional',
    alimentacao: 244, refeicao_barata: 9, restaurante_dois: 36, cinema: 7, creche: 300,
    t0c: 400,  t0p: 310,  t1c: 515,  t1p: 395,
    t2c: 670,  t2p: 520,  t3c: 870,  t3p: 655,
    passe: 30, util: 92,
  },
  'Leiria': {
    fonte: 'estimativa_regional',
    alimentacao: 248, refeicao_barata: 9.5, restaurante_dois: 37, cinema: 7, creche: 300,
    t0c: 415,  t0p: 320,  t1c: 535,  t1p: 410,
    t2c: 700,  t2p: 545,  t3c: 905,  t3p: 685,
    passe: 30, util: 95,
  },
  'Évora': {
    fonte: 'estimativa_regional',
    alimentacao: 245, refeicao_barata: 9, restaurante_dois: 36, cinema: 7, creche: 295,
    t0c: 408,  t0p: 315,  t1c: 525,  t1p: 400,
    t2c: 685,  t2p: 535,  t3c: 890,  t3p: 670,
    passe: 30, util: 94,
  },
  'Viseu': {
    fonte: 'estimativa_regional',
    alimentacao: 238, refeicao_barata: 8.5, restaurante_dois: 34, cinema: 7, creche: 280,
    t0c: 380,  t0p: 295,  t1c: 490,  t1p: 375,
    t2c: 640,  t2p: 498,  t3c: 830,  t3p: 625,
    passe: 28, util: 90,
  },
  'Covilhã': {
    fonte: 'estimativa_regional',
    alimentacao: 224, refeicao_barata: 8, restaurante_dois: 30, cinema: 6.5, creche: 250,
    t0c: 330,  t0p: 255,  t1c: 425,  t1p: 325,
    t2c: 555,  t2p: 430,  t3c: 720,  t3p: 545,
    passe: 25, util: 82,
  },
  'Castelo Branco': {
    fonte: 'estimativa_regional',
    alimentacao: 230, refeicao_barata: 8.5, restaurante_dois: 32, cinema: 7, creche: 260,
    t0c: 350,  t0p: 270,  t1c: 450,  t1p: 345,
    t2c: 590,  t2p: 458,  t3c: 765,  t3p: 578,
    passe: 25, util: 85,
  },
  'Guarda': {
    fonte: 'estimativa_regional',
    alimentacao: 216, refeicao_barata: 8, restaurante_dois: 29, cinema: 6, creche: 235,
    t0c: 305,  t0p: 235,  t1c: 393,  t1p: 300,
    t2c: 515,  t2p: 400,  t3c: 670,  t3p: 505,
    passe: 22, util: 80,
  },
  'Viana do Castelo': {
    fonte: 'estimativa_regional',
    alimentacao: 243, refeicao_barata: 9, restaurante_dois: 35, cinema: 7, creche: 285,
    t0c: 395,  t0p: 305,  t1c: 510,  t1p: 390,
    t2c: 665,  t2p: 515,  t3c: 865,  t3p: 650,
    passe: 28, util: 92,
  },
  'Bragança': {
    fonte: 'estimativa_regional',
    alimentacao: 210, refeicao_barata: 7.5, restaurante_dois: 28, cinema: 6, creche: 225,
    t0c: 295,  t0p: 228,  t1c: 380,  t1p: 291,
    t2c: 497,  t2p: 385,  t3c: 646,  t3p: 487,
    passe: 20, util: 78,
  },
  'Vila Real': {
    fonte: 'estimativa_regional',
    alimentacao: 222, refeicao_barata: 8, restaurante_dois: 30, cinema: 6.5, creche: 245,
    t0c: 328,  t0p: 253,  t1c: 422,  t1p: 323,
    t2c: 552,  t2p: 428,  t3c: 718,  t3p: 540,
    passe: 22, util: 82,
  },
  'Ponta Delgada': {
    fonte: 'estimativa_regional',
    alimentacao: 258, refeicao_barata: 10, restaurante_dois: 39, cinema: 7.5, creche: 310,
    t0c: 468,  t0p: 362,  t1c: 605,  t1p: 463,
    t2c: 790,  t2p: 614,  t3c: 1025, t3p: 773,
    passe: 30, util: 100,
  },
  'Angra do Heroísmo': {
    fonte: 'estimativa_regional',
    alimentacao: 248, refeicao_barata: 9.5, restaurante_dois: 37, cinema: 7, creche: 295,
    t0c: 440,  t0p: 340,  t1c: 568,  t1p: 434,
    t2c: 742,  t2p: 576,  t3c: 963,  t3p: 726,
    passe: 28, util: 95,
  },
  'Portimão': {
    fonte: 'estimativa_regional',
    alimentacao: 270, refeicao_barata: 11, restaurante_dois: 44, cinema: 8, creche: 335,
    t0c: 550,  t0p: 422,  t1c: 710,  t1p: 544,
    t2c: 928,  t2p: 720,  t3c: 1205, t3p: 908,
    passe: 35, util: 110,
  },
  'Albufeira': {
    fonte: 'estimativa_regional',
    alimentacao: 276, refeicao_barata: 11.5, restaurante_dois: 46, cinema: 8, creche: 350,
    t0c: 575,  t0p: 445,  t1c: 742,  t1p: 570,
    t2c: 970,  t2p: 752,  t3c: 1260, t3p: 950,
    passe: 35, util: 113,
  },
  'Lagos': {
    fonte: 'estimativa_regional',
    alimentacao: 272, refeicao_barata: 11, restaurante_dois: 44, cinema: 8, creche: 335,
    t0c: 555,  t0p: 428,  t1c: 716,  t1p: 549,
    t2c: 936,  t2p: 726,  t3c: 1215, t3p: 915,
    passe: 35, util: 110,
  },
  'Vilamoura': {
    fonte: 'estimativa_regional',
    alimentacao: 284, refeicao_barata: 12, restaurante_dois: 48, cinema: 8.5, creche: 380,
    t0c: 615,  t0p: 475,  t1c: 794,  t1p: 610,
    t2c: 1038, t2p: 806,  t3c: 1348, t3p: 1018,
    passe: 35, util: 118,
  },
  'Santarém': {
    fonte: 'estimativa_regional',
    alimentacao: 241, refeicao_barata: 9, restaurante_dois: 35, cinema: 7, creche: 280,
    t0c: 385,  t0p: 297,  t1c: 496,  t1p: 380,
    t2c: 649,  t2p: 503,  t3c: 843,  t3p: 636,
    passe: 28, util: 90,
  },
  'Tomar': {
    fonte: 'estimativa_regional',
    alimentacao: 230, refeicao_barata: 8.5, restaurante_dois: 33, cinema: 6.5, creche: 255,
    t0c: 352,  t0p: 272,  t1c: 454,  t1p: 347,
    t2c: 593,  t2p: 460,  t3c: 771,  t3p: 581,
    passe: 25, util: 85,
  },
  'Caldas da Rainha': {
    fonte: 'estimativa_regional',
    alimentacao: 244, refeicao_barata: 9, restaurante_dois: 36, cinema: 7, creche: 285,
    t0c: 394,  t0p: 305,  t1c: 508,  t1p: 390,
    t2c: 663,  t2p: 515,  t3c: 862,  t3p: 649,
    passe: 28, util: 92,
  },
  'Torres Vedras': {
    fonte: 'estimativa_regional',
    alimentacao: 260, refeicao_barata: 10, restaurante_dois: 39, cinema: 7.5, creche: 340,
    t0c: 500,  t0p: 390,  t1c: 645,  t1p: 495,
    t2c: 843,  t2p: 655,  t3c: 1095, t3p: 825,
    passe: 35, util: 104,
  },
  'Peniche': {
    fonte: 'estimativa_regional',
    alimentacao: 244, refeicao_barata: 9.5, restaurante_dois: 37, cinema: 7, creche: 290,
    t0c: 394,  t0p: 305,  t1c: 508,  t1p: 390,
    t2c: 663,  t2p: 515,  t3c: 862,  t3p: 649,
    passe: 28, util: 92,
  },
  'Nazaré': {
    fonte: 'estimativa_regional',
    alimentacao: 246, refeicao_barata: 9.5, restaurante_dois: 37, cinema: 7, creche: 295,
    t0c: 406,  t0p: 314,  t1c: 524,  t1p: 401,
    t2c: 685,  t2p: 531,  t3c: 889,  t3p: 671,
    passe: 28, util: 93,
  },
  'Sines': {
    fonte: 'estimativa_regional',
    alimentacao: 238, refeicao_barata: 9, restaurante_dois: 34, cinema: 7, creche: 275,
    t0c: 378,  t0p: 292,  t1c: 487,  t1p: 373,
    t2c: 637,  t2p: 494,  t3c: 827,  t3p: 624,
    passe: 28, util: 90,
  },
  'Maia': {
    fonte: 'estimativa_regional',
    alimentacao: 258, refeicao_barata: 10, restaurante_dois: 40, cinema: 7.5, creche: 330,
    t0c: 460,  t0p: 356,  t1c: 594,  t1p: 455,
    t2c: 776,  t2p: 602,  t3c: 1008, t3p: 761,
    passe: 35, util: 100,
  },
  'Valongo': {
    fonte: 'estimativa_regional',
    alimentacao: 241, refeicao_barata: 9, restaurante_dois: 36, cinema: 7, creche: 295,
    t0c: 395,  t0p: 306,  t1c: 510,  t1p: 391,
    t2c: 666,  t2p: 517,  t3c: 865,  t3p: 653,
    passe: 35, util: 94,
  },
  'Povoa de Varzim': {
    fonte: 'estimativa_regional',
    alimentacao: 252, refeicao_barata: 9.5, restaurante_dois: 38, cinema: 7, creche: 310,
    t0c: 430,  t0p: 333,  t1c: 555,  t1p: 425,
    t2c: 725,  t2p: 562,  t3c: 942,  t3p: 711,
    passe: 33, util: 97,
  },
  'Beja': {
    fonte: 'estimativa_regional',
    alimentacao: 215, refeicao_barata: 8, restaurante_dois: 30, cinema: 6.5, creche: 240,
    t0c: 318,  t0p: 246,  t1c: 410,  t1p: 314,
    t2c: 536,  t2p: 416,  t3c: 697,  t3p: 526,
    passe: 22, util: 80,
  },
};

export const TIPOS_APT = [
  { key: 't0', label: 'T0 — Estúdio' },
  { key: 't1', label: 'T1' },
  { key: 't2', label: 'T2' },
  { key: 't3', label: 'T3 ou maior' },
];
